<template>
  <div>
    <van-sticky>
      <van-nav-bar right-text="关注" class="header-bar"  @click-right="onClickRight"/>
    </van-sticky>
    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <div class="content">
          <img :src="env==='wwjrxx'? 'https://dstatic.wwjrxx.com/image/static/wwjrxx_gzh_logo.jpg':'https://dstatic.wwjrxx.com/image/static/wwgd_gzh_logo.jpg'"/>
          <van-icon name="close" color="#fff" size="30px" @click="show=false"/>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getStorage } from '../utils/common';
export default {
  data(){
    return {
      show: false,
      env: getStorage('env')
    }
  },
  methods: {
    onClickRight(){
      this.show = true
    }
  }
};
</script>

<style scoped>
 .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .content {
    background-color: #fff;
    width: 260px;
    height: 260px;
    text-align: center;
  }

  .content img{
    width: 100%;
  }
  /deep/ .van-nav-bar__text{
    color: #000;
  }
  /deep/ .van-overlay{
    z-index: 2001;
  }
</style>